/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { brandingGenerate } from '../../axios/brandingGenerate'
import type {
	BrandingGenerateError,
	BrandingGenerateRequest,
	BrandingGenerateResponse,
} from '../../types/BrandingGenerate'

export const brandingGenerateMutationKey = () => [{ url: '/brandings/generate' }] as const

export type BrandingGenerateMutationKey = ReturnType<typeof brandingGenerateMutationKey>

export type BrandingGenerateVariables = {
	data: BrandingGenerateRequest
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::generate */
export function useBrandingGenerate<TContext = unknown>(
	options?: UseMutationOptions<
		BrandingGenerateResponse,
		AxiosError<BrandingGenerateError>,
		BrandingGenerateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: brandingGenerateMutationKey(),
		mutationFn: ({ data }: BrandingGenerateVariables) => brandingGenerate(data, config).then(res => res.data),
		...options,
	})
}
